module.exports = __webpack_public_path__ + "static/media/Birthday-Party-thumbnail.2d17eb0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Birthday-Party-thumbnail.png
// module id = 124
// module chunks = 0